import { ChatTokenActions } from '../actions/chatToken';

const initialState = null;

const chatTokenReducer = (state = initialState, action: ChatTokenActions) => {
	switch (action.type) {
		case 'chat/add-token':
			return action.payload;
		case 'chat/remove-token':
			return initialState;
		default:
			return state;
	}
};

export default chatTokenReducer;
